/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'react-telephone-input/css/default.css';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import CustomFields from '../../../../components/customFields/CustomFields';
import SectionHeader from '../../../../components/sectionHeader';
import PERMITMODULE from '../../../../icons/PERMITMODULE.png';
import DEFAULTFIELDS from './DEFAULTFIELDS';
import styles from './form.module.scss';
import Button from '../../../../components/button';
import HeaderBack from '../../../../components/headerBack';
import { changeCurrentPage } from '../../../../general_redux/actions';
import {
  fetchspecificAdpLogs,
  initiateApplication,
  getAdpDefaultFields,
  getCurrentTenantPortalUsers,
  checkInitiatePermit,
  handleClearInitiateState
} from '../../redux/action';
import Loading from '../../../../components/loading';
import Attachments from '../../../forms/components/Attachments';
import { GetFileName, S3Uploads } from '../../../services';
import Spinner from '../../../../components/spinner';
import { searchUser } from '../../../inspections/redux/actions';
import PulpoField from '../../../../pulpo_visualizer/fields';
import Modal from '../../../../components/modal';

const Form = (props) => {
  const logId = props?.match?.params?.id;
  const dispatch = useDispatch();
  const history = useHistory();
  const [state, setState] = useState({
    answers: {
      attachments: [],
      offline_training: false,
      application_type: 'New'
    },
    formErrors: false
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const getSchemaStatus = useSelector(states => states?.permitManagement?.adpGetSchemaStatus);
  const loader = useSelector(
    states => states?.permitManagement?.adpInitiationStatus
  );
  const loaderForRenewal = useSelector(
    states => states?.permitManagement?.loader
  );
  const profile = useSelector(states => states.auth.profile);
  const ADPDEFAULTFIELDS = useSelector(
    states => states?.permitManagement?.adpDefaultFields
  );
  const adpSchema = useSelector(
    states => states?.permitManagement?.adpSchema
  );
  const currentTenantPortalUsers = useSelector(
    states => states?.permitManagement?.currentTenantPortalUsers
  );
  const newApplicaitonFields = DEFAULTFIELDS.map((ele) => {
    if (ele.id === 'application_type') {
      return {
        ...ele,
        values: [
          {
            key: 'New',
            value: 'New'
          }
        ]
      };
    }
    return { ...ele };
  });
  const [initFormFields, setInitFormFields] = useState(newApplicaitonFields);
  const [portalUserError, setPortalUserError] = useState(false);
  const initiateStatus = useSelector(states => states?.permitManagement?.checkInitiatedPermitAction);
  const initiatedPermitData = useSelector(states => states?.permitManagement?.initiatedPermitData);
  const [initiatedModal, setInitiatedModal] = useState(false);
  const portalUserDefault = [
    {
      id: 'designation',
      lock: false,
      type: 'string',
      title: adpSchema?.default_fields?.default_field?.find(ele => ele?.id === 'designation')?.title || 'Designation',
      widget: {
        type: 'charfield'
      },
      default: false,
      internal: false,
      required: true,
      list_view: false,
      enable_ocr: false,
      full_width: false,
      conditional: false,
      description: '',
      search_enable: '',
      source_fields: [],
      system_generated: false
    },
    {
      id: 'application_type',
      lock: false,
      type: 'select',
      title: 'Application Type',
      values: [
        {
          key: 'New',
          value: 'New'
        }
      ],
      widget: {
        type: 'dropdown'
      },
      default: false,
      internal: false,
      required: true,
      list_view: false,
      enable_ocr: false,
      full_width: false,
      conditional: false,
      description: '',
      search_enable: '',
      source_fields: [],
      system_generated: false
    }
  ];
  useEffect(() => {
    if (logId) {
      dispatch(fetchspecificAdpLogs(logId));
    }
  }, [dispatch, logId]);

  useEffect(() => {
    if (adpSchema) {
      let designation_title = adpSchema?.default_fields?.default_field?.find(
          ele => ele?.id === 'designation'
        )?.title || 'Designation';
      let updatedFormFields = initFormFields.map((ele) => {
        if (ele.id === 'designation' && designation_title) {
          return { ...ele, title: designation_title };
        }
        return { ...ele };
      });
      setInitFormFields(updatedFormFields);
    }
  }, [adpSchema]);

  useEffect(() => {
    dispatch(
      changeCurrentPage(profile?.permit_management?.driver_permit || 'ADP')
    );
    dispatch(searchUser());
    dispatch(getCurrentTenantPortalUsers());
  }, []);

  useEffect(() => {
    dispatch(getAdpDefaultFields());
  }, [dispatch]);

  useEffect(() => {
    if (initiateStatus?.success) {
      setIsLoading(false);
      if (initiatedPermitData?.length > 0) {
        setInitiatedModal(true);
        dispatch(handleClearInitiateState());
      } else {
        dispatch(handleClearInitiateState());
        if (ADPDEFAULTFIELDS?.initiateWithPortalUsers) {
          handelSubmitWithPortalUser(true);
        } else {
          handelSubmit(true);
        }
      }
    }
  }, [initiateStatus, dispatch, initiatedPermitData]);


  const handleCheckInitatePermits = () => {
    const currentUser = currentTenantPortalUsers?.find(user => user?.id === state.answers.portal_users);
    const data = { ...state.answers, ...currentUser };
    let phone = data?.phone && (data?.phone[0] + data?.phone.slice(1).replace(/[^\d]/g, '')) || undefined;
    let email = data?.email || undefined;
    let initiated_to = currentUser?.id || undefined;
    dispatch(checkInitiatePermit(phone, email, initiated_to, undefined));
  };

  if (state.answers.offline_training === false) {
    state.answers.attachments = [];
  }
  const getFileNames = async (count) => {
    const response = await GetFileName.getUploadFileName(count);
    return response;
  };
  const doS3Upload = async (files, fileIds, entity) => {
    const response = await S3Uploads.uploadFiles(
      files,
      fileIds.filename,
      entity
    );
    return response;
  };
  const handleUploadAttachment = async (attachments, entity) => {
    const attachmentIds = [];
    const newAttachments = [];
    if (attachments && attachments.length > 0) {
      attachments.forEach((e) => {
        if (!e.id) {
          newAttachments.push(e);
        }
      });
    }
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await getFileNames(newAttachments.length);
    }
    if (fileIds) {
      await doS3Upload(newAttachments, fileIds, entity).then(() => {
        fileIds.filename.forEach((id) => {
          attachmentIds.push(id.toString());
        });
      });
    }
    return attachmentIds;
  };

  const handleAnswerChanged = (answer, fieldId) => {
    setState({ ...state, answers: { ...state.answers, [fieldId]: answer } });
  };

  const handelSubmit = async (checkPermit) => {
    const fieldError = errors;
    let attachmentFields = state.answers.attachments;
    if (state.answers.application_type === '') {
      fieldError.application_type = true;
    } else {
      fieldError.application_type = false;
    }
    if (ADPDEFAULTFIELDS?.enableSingleName && ADPDEFAULTFIELDS?.selectedName) {
      if (ADPDEFAULTFIELDS?.selectedName === 'lastName') {
        fieldError.last_name = false;
      }
      if (ADPDEFAULTFIELDS?.selectedName === 'firstName') {
        fieldError.first_name = false;
      }
    }
    if (
      state.answers.offline_training
      && ADPDEFAULTFIELDS?.enable_attachments_mandatory_when_offline_training
    ) {
      fieldError.attachments = state.answers.attachments.length === 0;
    } else {
      delete fieldError.attachments;
    }

    const noErrors = Object.keys(fieldError).every(k => errors[k] === false);
    if (noErrors) {
      setIsLoading(true);
      if (!checkPermit) {
        handleCheckInitatePermits();
        return;
      }
      if (attachmentFields.length > 0) {
        attachmentFields = await handleUploadAttachment(
          attachmentFields,
          'adp_training'
        );
        state.answers.attachments = attachmentFields;
      }
      const data = { ...state.answers };
      data.phone = data.phone[0] + data.phone.slice(1).replace(/[^\d]/g, '');
      dispatch(initiateApplication(data));
      setState({ ...state, formErrors: false });
    } else {
      setState({ ...state, formErrors: true });
    }
  };

  const getRequired = (data) => {
    let requiredKeys = {};
    data.forEach((ele) => {
      if (ele.required) {
        requiredKeys = { ...requiredKeys, [ele.id]: true };
      }
      if (ADPDEFAULTFIELDS?.enableSingleName) {
        if (ADPDEFAULTFIELDS?.selectedName === 'firstName') {
          if (ele.required && ele.id === 'first_name') {
            requiredKeys = { ...requiredKeys, [ele.id]: false };
          }
        } else if (ele.required && ele.id === 'last_name') {
          requiredKeys = { ...requiredKeys, [ele.id]: false };
        }
      }
    });
    return requiredKeys;
  };

  const handleFieldErrorChanged = (id, value) => {
    setErrors({ ...errors, [id]: value });
  };

  useEffect(() => {
    setErrors(getRequired(DEFAULTFIELDS));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (loader?.success) {
      history.push('/adp/logs');
    }
  }, [loader, history]);

  const handelSubmitWithPortalUser = async (checkPermit) => {
    const currentUser = currentTenantPortalUsers?.find(
      user => user?.id === state.answers.portal_users
        );
    const fieldError = errors;
    let attachmentFields = state.answers.attachments;
    if (state.answers.application_type === '') {
      fieldError.application_type = true;
    } else {
      fieldError.application_type = false;
    }

    if (ADPDEFAULTFIELDS?.enableSingleName && ADPDEFAULTFIELDS?.selectedName) {
      if (ADPDEFAULTFIELDS?.selectedName === 'lastName') {
        fieldError.last_name = false;
      }
      if (ADPDEFAULTFIELDS?.selectedName === 'firstName') {
        fieldError.first_name = false;
      }
    }
    if (
      state.answers.offline_training
      && ADPDEFAULTFIELDS?.enable_attachments_mandatory_when_offline_training
    ) {
      fieldError.attachments = state.answers.attachments.length === 0;
    } else {
      delete fieldError.attachments;
    }
    if (!state?.answers?.portal_users) {
      setPortalUserError(true);
      return;
    }
      setPortalUserError(false);

    const noErrors = Object.keys(fieldError).every(k => errors[k] === false);

    if (noErrors) {
      setIsLoading(true);
      if (!checkPermit) {
        handleCheckInitatePermits();
        return;
      }
      if (attachmentFields.length > 0) {
        attachmentFields = await handleUploadAttachment(
          attachmentFields,
          'adp_training'
        );
        state.answers.attachments = attachmentFields;
      }
      const data = { ...state.answers, ...currentUser };
      data.phone = data.phone ? data.phone[0] + data.phone.slice(1).replace(/[^\d]/g, '') : '';
      data.initiated_to = state?.answers?.portal_users || currentUser?.id;
      dispatch(initiateApplication(data));
      setState({ ...state, formErrors: false });
    } else {
      setState({ ...state, formErrors: true });
    }
  };

  return (
    <>
      <Loading loadingStatus={loader.loading || (loaderForRenewal && logId) || getSchemaStatus?.loading} />
      <SectionHeader
        icon={PERMITMODULE}
        translationID=" "
        defaultTitle={`New ${profile?.permit_management?.driver_permit || 'ADP'} Application`}
        centered
        {...props}
      />
      <HeaderBack
        translationID="workorder.settings.back"
        translationDefault="Back"
        backRoute="/adp/logs"
      />
      <div className={styles.container}>
        <div className={styles.headder}>
          <FormattedMessage
            id=" "
            defaultMessage={`New ${profile?.permit_management?.driver_permit || 'ADP'} Application Form`}
            tagName="h4"
          />
        </div>
        <span className={styles.note}>
          <FormattedMessage
            id="application.note"
            defaultMessage="Please note: "
            tagName="b"
          />
          <FormattedMessage
            id=" "
            defaultMessage={`Renewal ${profile?.permit_management?.driver_permit || 'ADP'}
              applications should be submitted through the existing application`}
          />
        </span>
        {ADPDEFAULTFIELDS?.initiateWithPortalUsers ? (
            <div style={{ padding: '20px' }}>
              <PulpoField
                id="portal_users"
                key="portal_users"
                title="Please select portal users"
                handleValueChange={(e) => {
                  setState({
                    ...state,
                    answers: { ...state.answers, portal_users: e }
                  });
                }}
                answer={state?.answers?.portal_users}
                values={currentTenantPortalUsers?.map(i => ({
                  key: i?.id,
                  value: i?.id,
                  text: i?.fullname
                }))}
                handleFieldErrorChanged={() => {
                  setErrors({
                    ...errors,
                    first_name: false,
                    last_name: false,
                    phone: false
                  });
                  setPortalUserError(false);
                }}
                type="select"
                widget={{ type: 'singleSearch' }}
                isRequired
                showFieldErrors={portalUserError}
              />
              <CustomFields
                handleAnswerChanged={(a, b) => handleAnswerChanged(a, b)}
                handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)
                }
                showFormErrors={state.formErrors}
                requiredMap={getRequired(portalUserDefault)}
                fields={portalUserDefault}
                answers={state.answers}
                forQuestionMarkHelp
              />
              {!ADPDEFAULTFIELDS?.enable_external_training && !ADPDEFAULTFIELDS?.initiateWithPortalUsers && (
                <>
                  <input
                    type="checkbox"
                    id="adp_number"
                    onChange={(e) => {
                      setState({
                        ...state,
                        answers: {
                          ...state.answers,
                          offline_training: e.target.checked
                        }
                      });
                    }}
                    value={state?.answers?.offline_training}
                  />
                  <label htmlFor="adp_number" style={{ marginLeft: '1%' }}>
                    User Has Taken Offline Training
                  </label>
                </>
              )}
              {state?.answers?.offline_training && (
                <Attachments
                  key="attachments"
                  id="attachments"
                  type="attachments"
                  title="Attachments"
                  attachments={state?.answers?.attachments}
                  handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)
                  }
                  handleAnswerChanged={(a, b) => handleAnswerChanged(a, b)}
                  showFieldErrors={state.formErrors}
                  required={
                    ADPDEFAULTFIELDS?.enable_attachments_mandatory_when_offline_training
                  }
                />
              )}
            </div>
        ) : (
          <div style={{ padding: '20px' }}>
            <CustomFields
              handleAnswerChanged={(a, b) => handleAnswerChanged(a, b)}
              handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
              showFormErrors={state.formErrors}
              requiredMap={getRequired(initFormFields)}
              fields={initFormFields}
              answers={state.answers}
              forQuestionMarkHelp
            />
            {!ADPDEFAULTFIELDS?.enable_external_training && !ADPDEFAULTFIELDS?.initiateWithPortalUsers && (
              <>
                <input
                  type="checkbox"
                  id="adp_number"
                  onChange={(e) => {
                    setState({
                      ...state,
                      answers: {
                        ...state.answers,
                        offline_training: e.target.checked
                      }
                    });
                  }}
                  value={state?.answers?.offline_training}
                />
                <label htmlFor="adp_number" style={{ marginLeft: '1%' }}>
                  User Has Taken Offline Training
                </label>
              </>
            )}
            {state?.answers?.offline_training && (
              <Attachments
                key="attachments"
                id="attachments"
                type="attachments"
                title="Attachments"
                attachments={state?.answers?.attachments}
                handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)
                }
                handleAnswerChanged={(a, b) => handleAnswerChanged(a, b)}
                showFieldErrors={state.formErrors}
                required={
                  ADPDEFAULTFIELDS?.enable_attachments_mandatory_when_offline_training
                }
              />
            )}
          </div>
        )}
        <div className={styles.submitButton}>
          <Spinner active={isLoading && !loader.loading} />
          {ADPDEFAULTFIELDS?.initiateWithPortalUsers ? (
            <Button
              action="secondary"
              onClick={() => handelSubmitWithPortalUser(false)}
              translationID="adp.submit"
              defaultText={logId ? 'Renew' : 'Submit'}
              disabled={isLoading}
            />
          ) : (
            <Button
              action="secondary"
              onClick={() => handelSubmit(false)}
              translationID="adp.submit"
              defaultText={logId ? 'Renew' : 'Submit'}
              disabled={isLoading}
            />
          )}
        </div>
        <Modal
          showIn={initiatedModal}
          onClose={() => setInitiatedModal(false)}
          minHeight="150px"
          width="554px"
        >
          <div style={{ padding: '20px 20px 10px' }}>
            <FormattedMessage
              id="adp.application.restriction.warning.message.one"
              tagName="h5"
              defaultMessage={` An ${profile?.permit_management?.driver_permit || 'ADP'}
                application has already been initiated for this user.
                Kindly cancel the existing one if you need to re-initiate an application.
              `}
            />
            <FormattedMessage
              id="adp.application.restriction.warning.message.two"
              tagName="h5"
              defaultMessage={'For renewal of an approved application, please initiate the renewal from within the application itself.'}
            />
          </div>
          <div className={styles.submitButton}>
            <Button
              action="secondary"
              onClick={() => setInitiatedModal(false)}
              translationID="inspections.list.ok"
              defaultText="OK"
              />
          </div>
        </Modal>
      </div>
    </>
  );
};
export default Form;
